<template>
	<span v-if="isAdmin">
		<v-tooltip bottom>
			<template v-slot:activator="{ on }">
				<v-btn icon @click="handleOpen" v-on="on">
					<v-icon>group_add</v-icon>
				</v-btn>
			</template>
			<span>{{ $t('tooltip.candidate-access') }}</span>
		</v-tooltip>

		<v-dialog v-model="isVisible" max-width="640" persistent>
			<v-card>
				<v-card-title>{{ $t('label.candidate-access') }}</v-card-title>
				<v-card-text>
					<UserPicker
						v-model="selected"
						:users="users"
						:label="$t('label.candidate-access')"
						multiple
						dense
					></UserPicker>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="handleClose" :disabled="isSaving">
						{{ $t('button.close') }}
					</v-btn>
					<v-btn
						color="primary"
						@click="handleSave"
						:loading="isSaving"
					>
						{{ $t('button.save') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</span>
</template>

<script>
import { mapState } from 'vuex';
import UserPicker from '@/components/shared/userPicker/UserPicker';
import api from '@/api';

// Only ADMIN (666) and above may manage a candidate's share list — mirrors the
// backend authorization on PUT /v1/hire-app/candidates/:id/shared-users.
const ADMIN_ROLE = 666;

export default {
	name: 'CandidateSharedUsers',
	components: {
		UserPicker,
	},
	props: {
		candidate: {
			type: Object,
			required: true,
		},
	},
	computed: {
		...mapState({
			users: state => state.users.items,
			userRole: state => state.currentUser.userRole,
		}),
		isAdmin() {
			return parseInt(this.userRole, 10) >= ADMIN_ROLE;
		},
	},
	data() {
		return {
			isVisible: false,
			isSaving: false,
			selected: [],
		};
	},
	created() {
		// The picker needs the full company user list. Notes.vue also relies on
		// it, but refresh defensively in case this component mounts first.
		if (!this.users || this.users.length === 0) {
			this.$store.dispatch('users/get', { updateStore: true });
		}
	},
	methods: {
		handleOpen() {
			this.selected = Array.isArray(this.candidate.shared_users)
				? [...this.candidate.shared_users]
				: [];
			this.isVisible = true;
		},
		handleClose() {
			this.isVisible = false;
		},
		handleSave() {
			this.isSaving = true;
			api.candidates
				.updateSharedUsers(this.candidate.id, this.selected)
				.then(() => {
					this.isVisible = false;
					this.$emit('updated');
				})
				.catch(error => {
					this.$emit('error', error);
				})
				.finally(() => {
					this.isSaving = false;
				});
		},
	},
};
</script>
